import { shouldHideWithLocaleOverride } from '@/utils/localeOverride';
import { Entry } from 'contentful';

export interface OverridableProps {
  children: React.ReactNode;
  content: Entry<any> | undefined;
}

const Overridable = ({ children, content }: OverridableProps) => {
  if (shouldHideWithLocaleOverride(content?.fields?.localeOverride)) {
    return null;
  } else {
    return <>{children}</>;
  }
};

export default Overridable;
